import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _styled from "@emotion/styled/base";
var _excluded = ["tokens", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { withDesignTokens } from '@segment/matcha/useDesignTokens';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";

var BaseBlockquote = function BaseBlockquote(_ref) {
  var tokens = _ref.tokens,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  return _jsx(Blockquote, _objectSpread(_objectSpread(_objectSpread({}, tokens), rest), {}, {
    children: children
  }));
};

var Blockquote = /*#__PURE__*/_styled("blockquote", true ? {
  target: "e177des50"
} : {
  target: "e177des50",
  label: "Blockquote"
})("padding-left:21px;border-left:", function (_ref2) {
  var borderColor = _ref2.borderColor;
  return "3px solid ".concat(borderColor);
}, ";margin:24px 0px;" + (true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

export default withDesignTokens(BaseBlockquote, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      borderColor: theme.palette.brand.darkAcai[400]
    };
  },
  dark: function dark(theme) {
    return {
      borderColor: theme.palette.brand.darkAcai[400]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      borderColor: theme.palette.twilio.gray[20]
    };
  },
  twilioDark: function twilioDark(theme) {
    return {
      borderColor: theme.palette.twilio.gray[20]
    };
  },
  cdpWeek2023: function cdpWeek2023(theme) {
    return {
      borderColor: theme.palette.cdpWeek2023.gray[20]
    };
  }
});